import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[whatsappShare]'
})
export class WhatsappShareDirective {
  @Input() shareText: string;

  constructor() { }

  @HostListener('click')
  onClick() {
      const encodedShareText = encodeURIComponent(this.shareText);
      const encodedShareUrl = encodeURIComponent(window.location.href);
      const whatsappShareUrl = `https://api.whatsapp.com/send?text=${encodedShareText}%20${encodedShareUrl}`;
      window.open(whatsappShareUrl, '_blank');
    
  }
}
